import { BlockStack, InlineStack, Button, Card, ActionList, InlineGrid, Icon, Popover, Page, Text, TextField, TopBar, MediaCard, Link, ProgressBar, Box, Pagination, VideoThumbnail, useBreakpoints } from "@shopify/polaris";
import { EditIcon, ChevronRightIcon, CaretDownIcon, EnvelopeIcon, OrderIcon, ComposeIcon, PersonAddIcon, ChartFunnelIcon, CursorFilledIcon, DiscountIcon, CreditCardIcon, CheckCircleIcon, AlertCircleIcon, ImagesIcon, EmailIcon, DomainLandingPageIcon } from "@shopify/polaris-icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AppLayout from "../components/layout";
import ManageBuckets from "../components/ManageBuckets";
import MessagesLog from "../components/MessagesLog";
import PerformanceGraph from "../components/PerformanceGraph";
import PostsLibrary from "../components/PostsLibrary";
import { usePartnerUp } from "../providers/PartnerUpStoreProvider";
import { dealHasOverdueContent, dealNeedsAffiliateCode, dealNeedsContentReview, fixedDealHasNewPosts, getCreatorAffiliatePaymentSummary, getDaysBetweenDates, getMonthDayString, graphColorCodes, numberToUSD, shortenNumber } from "../utils";

export default function Home() {
  const { deals, store, leads, allMessages, campaigns, allEmails, allCodes, creatorPosts, outreachInvites, content } = usePartnerUp();
  const navigate = useNavigate()

  const { mdUp } = useBreakpoints();

  const [manageBucketsOpen, setManageBucketsOpen] = useState(false)
  const [postsIndex, setPostsIndex] = useState(0)

  const [dateRange, setDateRange] = useState('last7')
  const [datesPopoverActive, setDatesPopoverActive] = useState(false)

  const [datePickerOpen, setDatePickerOpen] = useState(false)


  useEffect(() => {
    navigate('/creators')
  }, []);

  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

  const tomorrowMidnight = new Date();
  tomorrowMidnight.setDate(tomorrowMidnight.getDate() + 1);
  tomorrowMidnight.setHours(0, 0, 0, 0);
  const [selectedDates, setSelectedDates] = useState({
    start: new Date(oneWeekAgo),
    end: tomorrowMidnight,
  });

  useEffect(() => {
    if (dateRange === 'custom') {
      setDatePickerOpen(true)
    } else if (dateRange === 'allTime') {
      setSelectedDates({
        start: new Date('2024-01-01'),
        end: tomorrowMidnight,
      })
    } else if (dateRange === 'last7') {
      setSelectedDates({
        start: new Date(oneWeekAgo),
        end: tomorrowMidnight,
      })
    } else if (dateRange === 'last30') {
      const oneMonthAgo = new Date();
      oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
      setSelectedDates({
        start: oneMonthAgo,
        end: tomorrowMidnight,
      })
    } else if (dateRange === 'last90') {
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setDate(threeMonthsAgo.getDate() - 90);
      setSelectedDates({
        start: threeMonthsAgo,
        end: tomorrowMidnight,
      })
    }
  }, [dateRange])

  const days = getDaysBetweenDates(selectedDates.start, selectedDates.end)
  const creatorsTimeSeries = Array(days?.length).fill(0)
  const revenueTimeSeries = Array(days?.length).fill(0)
  const clicksTimeSeries = Array(days?.length).fill(0)
  const postsTimeSeries = Array(days?.length).fill(0)
  const engagementsTimeSeries = Array(days?.length).fill(0)

  let totalNewCreators = 0;
  let totalPosts = 0;
  let totalEngagements = 0;
  let totalClicks = 0;
  let totalRevenue = 0;

  console.log('days', days)
  leads?.forEach(l => {
    const addedDate = new Date(l.addedDate)
    const dateString = getMonthDayString(addedDate)
    const dateIndex = days.indexOf(dateString)
    if (days.includes(dateString)) {
      if (creatorsTimeSeries[dateIndex]) creatorsTimeSeries[dateIndex] += 1
      else creatorsTimeSeries[dateIndex] = 1
      totalNewCreators++
    }
  }, {})

  creatorPosts?.forEach(p => {
    const postDate = new Date(p.timestamp * 1000)
    const dateString = getMonthDayString(postDate)
    const dateIndex = days.indexOf(dateString)
    if (days.includes(dateString)) {
      if (postsTimeSeries[dateIndex]) postsTimeSeries[dateIndex] += 1
      else postsTimeSeries[dateIndex] = 1
      totalPosts++
    }

    if (p?.stats?.engagementTimeSeries) {
      Object.keys(p.stats.engagementTimeSeries)?.sort((a, b) => {
        return new Date(a) - new Date(b)
      }).forEach((date, i, array) => {
        const dateString = getMonthDayString(new Date(date))
        const dateIndex = days.indexOf(dateString)
        if (days.includes(dateString)) {
          const prevDate = i !== 0 ? array[i - 1] : null
          const prevDateValue = i !== 0 ? p.stats.engagementTimeSeries[prevDate] || 0 : 0;
          const dateValue = p.stats.engagementTimeSeries[date] || 0
          const curEngagements = (dateValue?.comments || 0) + (dateValue?.likes || 0) + (dateValue?.plays || dateValue?.views || 0)
          const prevEngagements = (prevDateValue?.comments || 0) + (prevDateValue?.likes || 0) + (prevDateValue?.plays || prevDateValue?.views || 0)
          const difference = curEngagements - prevEngagements
          console.log("DIFF", difference)
          const engagementsCount = difference > 0 ? difference : 0
          if (engagementsTimeSeries[dateIndex]) engagementsTimeSeries[dateIndex] += engagementsCount
          else engagementsTimeSeries[dateIndex] = engagementsCount
          totalEngagements += engagementsCount
        }
      })
    }
  })

  allCodes?.forEach(c => {
    console.log('code is', c)
    if (c?.clicksByDate) {
      Object.keys(c.clicksByDate).forEach(date => {
        const dateString = getMonthDayString(new Date(date))
        console.log('dateString', dateString)
        const dateIndex = days.indexOf(dateString)
        if (days.includes(dateString)) {
          const clicksCount = c.clicksByDate[date] || 0
          if (clicksTimeSeries[dateIndex]) clicksTimeSeries[dateIndex] += clicksCount
          else clicksTimeSeries[dateIndex] = clicksCount
          totalClicks += clicksCount
        }
      })
    }
    if (c?.orders?.length) {
      c.orders.forEach(o => {
        const orderDate = new Date(o.processedAt)
        const dateString = getMonthDayString(orderDate)
        const dateIndex = days.indexOf(dateString)
        const orderValue = Number(o?.subtotalPriceSet?.shopMoney?.amount || 0)
        if (days.includes(dateString)) {
          if (revenueTimeSeries[dateIndex]) revenueTimeSeries[dateIndex] += orderValue
          else revenueTimeSeries[dateIndex] = orderValue
          totalRevenue += orderValue
        }
      })
    }
  })

  console.log('clicksTimeSeries', clicksTimeSeries)

  const creatorTasks = deals?.filter(deal => deal.status === 'active' || deal.status === 'formSubmitted').reduce((acc, deal) => {
    const creator = leads?.find(l => l.id === deal.creatorID)
    const dealReviewContent = content?.filter(c => c.dealID === deal.id && c.status === 'needsReview')
    /*
    if (getRequiresPayment(deal, content)) {
      acc['Payments Due'].value++;
      acc['Payments Due'].creators = [...acc['Payments Due'].creators, creator]
      acc['Payments Due'].deals = [...acc['Payments Due'].deals, deal]
    }
*/
    if (creator?.hidden) {
      return acc
    }
    if (deal.status === 'formSubmitted') {
      acc['Applied for Campaign'].value++;
      acc['Applied for Campaign'].creators = [...acc['Applied for Campaign'].creators, creator]
      acc['Applied for Campaign'].deals = [...acc['Applied for Campaign'].deals, deal]
      return acc
    }
    if (dealNeedsContentReview(deal, dealReviewContent)) {
      acc['Content Review'].value++;
      acc['Content Review'].creators = [...acc['Content Review'].creators, creator]
      acc['Content Review'].deals = [...acc['Content Review'].deals, deal]
    }
    if (dealHasOverdueContent(deal)) {
      acc['Content Overdue'].value++;
      acc['Content Overdue'].creators = [...acc['Content Overdue'].creators, creator]
      acc['Content Overdue'].deals = [...acc['Content Overdue'].deals, deal]
    }
    if (dealNeedsAffiliateCode(deal, allCodes)) {
      acc['Need Affiliate Code'].value++;
      acc['Need Affiliate Code'].creators = [...acc['Need Affiliate Code'].creators, creator]
      acc['Need Affiliate Code'].deals = [...acc['Need Affiliate Code'].deals, deal]
    }
    const newPosts = fixedDealHasNewPosts(deal, creatorPosts?.filter(p => p.dealID === deal.id && !p.paid))
    if (newPosts) {
      acc['New Posts'].value += newPosts;
      acc['New Posts'].creators = [...acc['Deals Complete'].creators, creator]
      acc['New Posts'].deals = [...acc['Deals Complete'].deals, deal]
    }
    return acc;
  }, {
    'Need Order': { value: 0, creators: [], deals: [], singularText: 'Needs Order', icon: <Icon source={OrderIcon} tone="subdued" /> },
    'Content Review': { value: 0, creators: [], deals: [], singularText: 'Needs Content Review', icon: <Icon source={ComposeIcon} tone="subdued" /> },
    "Applied for Campaign": { value: 0, creators: [], deals: [], singularText: 'Applied for Campaign', icon: <Icon source={ChartFunnelIcon} tone="subdued" /> },
    'Need Affiliate Code': { value: 0, creators: [], deals: [], singularText: 'Needs Affiliate Code', icon: <Icon source={DiscountIcon} tone="subdued" /> },
    'Commission Due': { value: 0, creators: [], deals: [], singularText: 'Commission Due', icon: <Icon source={CreditCardIcon} tone="subdued" /> },
    'Deals Complete': { value: 0, creators: [], deals: [], singularText: 'Deal Complete', icon: <Icon source={CheckCircleIcon} tone="subdued" /> },
    'Content Overdue': { value: 0, creators: [], deals: [], singularText: 'Content Overdue', icon: <Icon source={AlertCircleIcon} tone="subdued" /> },
    'New Posts': { value: 0, creators: [], deals: [], singularText: 'New Posts', icon: <Icon source={ImagesIcon} tone="subdued" /> },
  })

  leads?.forEach(lead => {
    const affiliateSummary = getCreatorAffiliatePaymentSummary(lead?.id, allCodes)
    if (affiliateSummary?.amountDue) {
      creatorTasks['Commission Due'].value += parseFloat(affiliateSummary?.amountDue, 2)
      creatorTasks['Commission Due'].creators = [...creatorTasks['Commission Due'].creators, lead]
    }
  })

  const tasks = [];

  const unreadEmailsCount = allEmails?.filter(email => email?.authorType !== 'store' && email?.read === false)?.length

  if (unreadEmailsCount) {
    tasks.push({
      string: `${unreadEmailsCount} Unread Emails`,
      onClick: () => navigate('/emails'),
      icon: <Icon source={EmailIcon} tone="subdued" />
    })
  }

  const repliesWithoutDeals = outreachInvites?.filter(invite => invite.status === 'replied' && !deals?.find(d => (d.creatorID === invite.creatorID && d.campaignID === invite.campaignID)))
  if (repliesWithoutDeals?.length) {
    tasks.push({
      string: `${repliesWithoutDeals?.length} Replied to Outreach`,
      onClick: () => {
        navigate('/campaigns')
      },
      icon: <Icon source={EnvelopeIcon} tone="subdued" />
    })
  }

  Object.keys(creatorTasks || {}).forEach(task => {
    const taskCategory = creatorTasks[task];
    if (taskCategory.value) {
      tasks.push({
        string: taskCategory?.singularText === 'Commission Due' ? `${numberToUSD(taskCategory?.value)} Commission Due` : `${taskCategory.value} ${taskCategory?.value === 1 ? taskCategory?.singularText : task}`,
        creators: taskCategory.creators,
        onClick: () => {
          if (taskCategory?.singularText === 'Commission Due') {
            navigate('/payments')
          } else {
            navigate('/creators/' + taskCategory.creators?.[0]?.id)
          }
        },
        icon: taskCategory.icon
      })
    }
  })

  const leadsSubmittedForm = leads?.filter(lead => lead.status === 'newLead' && !lead?.hidden)
  if (leadsSubmittedForm?.length) {
    tasks.push({
      string: `${leadsSubmittedForm.length} New Leads`,
      creators: leadsSubmittedForm,
      onClick: () => {
        navigate('/creators/' + leadsSubmittedForm?.[0]?.id)
      },
      icon: <Icon source={DomainLandingPageIcon} tone="subdued" />
    })
  }

  const setupTasks = {
    leads: leads?.length || 0 > 4,
    campaign: !!(campaigns?.length),
    invite: !!leads?.find(l => l.status === 'needsInvite'),
    activate: !!leads?.find(l => l.status === 'inCampaign')
  }
  let card;
  if (!setupTasks.leads) {
    card = (
      <MediaCard
        title="Save 10 Creators"
        description="Start Searching For & Saving Creators"
        size="small"
        primaryAction={{
          content: 'Search',
          onAction: () => navigate('/search'),
        }}
        secondaryAction={{
          content: 'Watch Tutorial',
          onAction: () => {
            navigate('/tutorial?index=1')
          }
        }}
      >
        <VideoThumbnail onClick={() => {
          navigate('/tutorial?index=1')
        }} videoLength={281} thumbnailUrl="https://assets.codepen.io/6060109/scrape-img.png" />
      </MediaCard>
    )
  } else if (!setupTasks.invite) {
    card = (
      <MediaCard
        title="Invite a Creator"
        description="Send a Hello Email to a Creator to Start a Conversation."
        size="small"
        primaryAction={{
          content: 'Invite',
          onAction: () => navigate('/creators'),
        }}
        secondaryAction={{
          content: 'Watch Tutorial',
          onAction: () => {
            navigate('/creators')
          }
        }}
      >
        <VideoThumbnail onClick={() => {
          navigate('/tutorial?index=3')
        }} videoLength={212} thumbnailUrl="https://assets.codepen.io/6060109/campaign-th.png" />
      </MediaCard>
    )
  } else if (!setupTasks.campaign) {
    card = (
      <MediaCard
        title="Create a Contract"
        description="Create a Contract Template you can onboard creators with."
        size="small"
        primaryAction={{
          content: 'Create',
          onAction: () => navigate('/campaigns'),
        }}
        secondaryAction={{
          content: 'Watch Tutorial',
          onAction: () => {
            navigate('/tutorial?index=2')
          }
        }}
      >
        <VideoThumbnail onClick={() => {
          navigate('/creators')
        }} videoLength={147} thumbnailUrl="https://assets.codepen.io/6060109/c-2.png" />
      </MediaCard>
    )
  } else if (!setupTasks.activate) {
    card = (
      <MediaCard
        title="Activate a Creator"
        description="Create a contract & send it to a creator for submission."
        size="small"
        primaryAction={{
          content: 'Activate',
          onAction: () => {
            navigate('/creators')
          },
        }}
        secondaryAction={{
          content: 'Watch Tutorial',
          onAction: () => {
            navigate('/tutorial?index=4')
          }
        }}
      >
        <VideoThumbnail onClick={() => {
          navigate('/tutorial?index=4')
        }} videoLength={175} thumbnailUrl="https://assets.codepen.io/6060109/cont.png" />
      </MediaCard>
    )
  }

  const openedCount = outreachInvites?.filter(i => i.status === 'opened' || i.status === 'replied')?.length || 0
  const repliedCount = outreachInvites?.filter(i => i.status === 'replied')?.length || 0
  const outreachActivatedCount = deals?.filter(d => {
    const outreachMatch = outreachInvites?.find(i => i.status === 'replied' && (d.creatorID === i.creatorID && d.campaignID === i.campaignID))
    return outreachMatch
  })?.length || 0

  return (
    <AppLayout>
      <Page fullWidth>
        <InlineGrid columns={{ xs: '1', md: ['twoThirds', 'oneThird'] }} gap="500">
          <BlockStack gap="500">
            <BlockStack gap="800">
              {
                card ? (
                  <BlockStack gap="500">
                    <InlineStack blockAlign="center" align="space-between">
                      <Text variant="headingLg">What to Do Next</Text>
                      <BlockStack inlineAlign="end">
                        <Text>Need Help?</Text>
                        <InlineStack gap="100">
                          <Link removeUnderline onClick={() => {
                            window.Beacon('toggle')
                          }} external>Chat</Link>
                          <Text>or Email support@partnerup.net</Text>
                        </InlineStack>
                      </BlockStack>
                    </InlineStack>
                    <BlockStack gap="300">
                      {card}
                    </BlockStack>
                  </BlockStack>
                ) : null
              }
              <BlockStack gap="300">
                <Text variant="headingLg">Tasks</Text>
                {
                  tasks?.length ? (
                    <InlineGrid columns={{ xs: "1", md: "3" }} gap="300">
                      {tasks.map((task, i) => {
                        console.log('task', task)
                        return (
                          <Button key={i} onClick={task.onClick} >
                            <Box paddingBlockStart="3" paddingBlockEnd="3">
                              <InlineStack blockAlign="center" align="center" gap="100">
                                <InlineStack>
                                  {task.icon}
                                </InlineStack>
                                <Text>{task.string}</Text>
                              </InlineStack>
                            </Box>
                          </Button>
                        )
                      })
                      }
                    </InlineGrid>
                  ) : (
                    <MediaCard title="You're All Caught Up!" description="None Right Now" size="small">
                      <div style={{
                        // backgroundImage: `url(${sparkleVector})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        width: '100%',
                        height: '75px'
                      }} />
                    </MediaCard>
                  )
                }
              </BlockStack>
            </BlockStack>
            <BlockStack gap="500">
              <BlockStack gap="500">
                <InlineStack align="space-between">
                  <Text variant="headingLg">Stats</Text>
                  <InlineStack gap="300">
                    <Popover active={datesPopoverActive} activator={<Button plain icon={CaretDownIcon} onClick={() => setDatesPopoverActive(!datesPopoverActive)}>
                      {
                        dateRange === 'last7' ? 'Last 7 Days' :
                          dateRange === 'last30' ? 'Last 30 Days' :
                            'Last 90 Days'
                      }
                    </Button>} onClose={() => setDatesPopoverActive(false)}>
                      <ActionList actionRole="menuitem"
                        items={[
                          {
                            content: 'Last 7 Days', onAction: () => {
                              setDateRange('last7')
                              setDatesPopoverActive(false)
                            }
                          },
                          {
                            content: 'Last 30 Days', onAction: () => {
                              setDateRange('last30')
                              setDatesPopoverActive(false)
                            }
                          },
                          {
                            content: 'Last 90 Days', onAction: () => {
                              setDateRange('last90')
                              setDatesPopoverActive(false)
                            }
                          },
                        ]} />
                    </Popover>
                    {
                      /*
                      <Popover active={statsPopoverActive} activator={<Button plain icon={DropdownMinor} onClick={() => setStatsPopoverActive(!statsPopoverActive)}>Change Graphs</Button>} onClose={() => setStatsPopoverActive(false)}>
                        <OptionList title="Show Graphs" onChange={(values) => {
                        }} options={[
                          ]} selected={[]} />
                      </Popover>
                        */
                    }
                  </InlineStack>
                </InlineStack>
                <BlockStack gap="300">
                  <InlineGrid columns={{ xs: "2", md: "3" }} gap="300">
                    <PerformanceGraph noAxes={true} title={`${totalNewCreators} New Creators`} label="New Creators" height="50px" timeSeriesRaw={creatorsTimeSeries} labels={days} typeTab={2} />
                    <PerformanceGraph noAxes={true} title={`${totalPosts} Posts`} label="Posts" height="50px" timeSeriesRaw={postsTimeSeries} labels={days} typeTab={2} />
                    <PerformanceGraph noAxes={true} title={`${shortenNumber(totalEngagements)} Engagements`} label="Engagements" height="50px" timeSeriesRaw={engagementsTimeSeries} labels={days} typeTab={2} />
                  </InlineGrid>
                </BlockStack>
              </BlockStack>
              <BlockStack gap="300">
                <InlineStack align="space-between" blockAlign="center">
                  <Text variant="headingLg">Recent Posts</Text>
                  <InlineStack gap="100">
                    <Text color="subdued">Refreshed every 24h</Text>
                    {
                      creatorPosts?.length > 3 ? (
                        <Pagination
                          onPrevious={() => {
                            setPostsIndex(postsIndex - 1)
                          }}
                          onNext={() => {
                            setPostsIndex(postsIndex + 1)
                          }}
                          hasPrevious={postsIndex > 0}
                          hasNext={((postsIndex * 3) + 3) < (creatorPosts?.length)}
                        />
                      ) : (
                        null
                      )
                    }
                  </InlineStack>
                </InlineStack>
                <PostsLibrary showHeader={false} posts={creatorPosts?.sort((a, b) => {
                  return b.timestamp - a.timestamp
                }).slice(postsIndex * 3, (postsIndex * 3) + 3) || []} columns="3" />
              </BlockStack>
            </BlockStack>
          </BlockStack>
          <BlockStack gap="500">
            <BlockStack gap="500">
              <InlineStack align="space-between" blockAlign="center">
                <Text variant="headingLg">Funnel</Text>
                {
                  /*
                  <Select label="Sequence" labelInline options={[
                    { label: 'All', value: 'all' },
                  ]} value="all" />
*/
                }
              </InlineStack>
              <Card>
                <BlockStack gap="500">
                  <BlockStack gap="100" inlineAlign="center">
                    <div style={{ width: '80%', height: '50px', borderRadius: '8px', background: `linear-gradient(201deg, rgba(250,175,80,0.3) 0%, rgba(247,89,88,0.3) 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', clipPath: 'polygon(0 0, 100% 0, 95% 100%, 5% 100%)' }} >
                      <Text variant="bodyMd">{outreachInvites?.length || 0} Contacted</Text>
                    </div>
                    <div style={{ width: '70%', height: '50px', borderRadius: '8px', position: 'relative', background: `linear-gradient(201deg, rgba(247,247,88,0.3) 0%, rgba(250,138,80,0.3) 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', clipPath: 'polygon(0 0, 100% 0, 95% 100%, 5% 100%)' }} >
                      <Text>{openedCount} Opened</Text>
                      <div style={{ position: 'absolute', fontWeight: '800', right: '15px', color: graphColorCodes[8] }}>
                        {outreachInvites?.length ? `${Math.round((openedCount / outreachInvites?.length) * 100)}%` : '0%'}
                      </div>
                    </div>
                    <div style={{ width: '60%', position: 'relative', height: '50px', borderRadius: '8px', background: `linear-gradient(201deg, rgba(157,247,88,0.3) 0%, rgba(247,247,88,0.3) 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', clipPath: 'polygon(0 0, 100% 0, 95% 100%, 5% 100%)' }} >
                      <Text>{repliedCount} Replied</Text>
                      <div style={{ fontWeight: '800', position: 'absolute', right: '15px', color: graphColorCodes[0] }}>
                        {openedCount ? `${Math.round((repliedCount / outreachInvites?.length) * 100)}%` : '0%'}
                      </div>
                    </div>
                    <div style={{ width: '50%', position: 'relative', height: '50px', borderRadius: '8px', background: `linear-gradient(201deg, rgba(88,247,228,0.3) 0%, rgba(157,247,88,0.3) 100%)`, display: 'flex', alignItems: 'center', justifyContent: 'center', clipPath: 'polygon(0 0, 100% 0, 95% 100%, 5% 100%)' }} >
                      <Text>{outreachActivatedCount} Activated</Text>
                      <div style={{ position: 'absolute', fontWeight: '800', right: '15px', color: graphColorCodes[3] }}>
                        {repliedCount ? `${Math.round((outreachActivatedCount / outreachInvites?.length) * 100)}%` : '0%'}
                      </div>
                    </div>
                  </BlockStack>
                </BlockStack>
              </Card>
            </BlockStack>
            {
              /*
              <BlockStack gap="500">
                <ManageBuckets open={manageBucketsOpen} onClose={() => setManageBucketsOpen(false)} />
                  <BlockStack gap="500">
                    <InlineStack blockAlign="center" align="space-between">
                      <Text variant="headingLg">Creator Buckets</Text>
                      <Button size="slim" onClick={() => setManageBucketsOpen(true)} icon={EditIcon}>Add / Edit</Button>
                    </InlineStack>
                    <Card padding="0">
                      <ActionList
                        actionRole="menuitem"
                        sections={[...(store?.buckets || [])?.map(b => {
                          const bucketLeads = leads?.filter(l => l.buckets?.includes(b.id) && !l.hidden)
                          return {
                            items: [{
                              prefix: <Text variant="headingXl">{b.emoji}</Text>,
                              content: (
                                <BlockStack align="start">
                                  <Text variant="headingSm">{b.name}</Text>
                                  <Text variant="bodyMd">{bucketLeads?.length || 0} Creators</Text>
                                </BlockStack>
                              ),
                              onAction: () => {
                                navigate('/creators?bucket=' + b.id)
                              },
                              suffix: (
                                <InlineStack gap="100">
                                  <Icon source={ChevronRightIcon} />
                                </InlineStack>
                              ),
                            }]
                          }
                        }),
                        {
                          items: [{
                            prefix: <Text variant="headingLg">✖️</Text>,
                            content: (
                              <BlockStack align="start">
                                <Text variant="headingSm">Uncategorized</Text>
                                <Text variant="bodyMd">{leads?.filter(l => !l.buckets?.every(b => {
                                  return !store?.buckets?.includes(b?.id)
                                }) && !l.hidden)?.length || 0} Creators</Text>
                              </BlockStack>
                            ),
                            onAction: () => {
                              navigate('/creators?bucket=none')
                            },
                            suffix: (
                              <InlineStack gap="100">
                                <Icon source={ChevronRightIcon} />
                              </InlineStack>
                            ),
                          }]
                        }
                        ]}
                      />
                    </Card>
                  </BlockStack>
                </BlockStack>
                */
            }
            <BlockStack gap="300">
              <Text variant="headingLg">Activity</Text>
              <MessagesLog allMessages={true} messages={allMessages} />
            </BlockStack>
          </BlockStack>
        </InlineGrid>
      </Page>
    </AppLayout>
  )
}
